import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { CardDetailPage } from "@/features/cards/pages/card-detail-page/card-detail-page";

export const Route = createFileRoute(
	"/_authenticated/admin/charging/cards/$cardId"
)({
	head: () => pageTitle("Charging card"),
	component: CardDetailPage,
});
